import { CPRow } from "./types";

const getExportProductName = (row: CPRow): string => {
  const { PartName, APILeft, APIRight } = row;
  const specialValues = ["WBQV", "WBDV", "WBSV"];

  const partNamesToRemove = [
      "Vertical Panel - Floor",
      "Steel Angle L Bracket",
      "Angle Bracket Cover",
      "Screw #8 x 1-1/2 Flat Robertson",
      "Screw #8 x 3/4 Pan Robertson",
      "Titus Screw-in Dowel",
      "Bottom Fixed Shelf",
      "Door",
      "Half Overlay Soft Close Hinge with Plate",
      "Titus Double Dowel",
      "Titus Cam Fitting",
      "Cleat"
  ];
  
  const regexRemove = new RegExp(partNamesToRemove.join("|"), "i");

  // Remove parts matching the list if APILeft or APIRight contains a special value
  if (regexRemove.test(PartName) && specialValues.some(value => [APILeft, APIRight].includes(value))) {
      return "";
  }

  // Rename "Top Fixed Shelf" to "Murphy Bed Cabinet" when APILeft or APIRight matches special values
  if (/Top Fixed Shelf/i.test(PartName) && specialValues.some(value => [APILeft, APIRight].includes(value))) {
      return "Murphy Bed Cabinet";
  }

  // Name mappings
  const nameMatchers = new Map([
      [/Cab Door/i, "Cab Door"],
      [/Drawer (Large|Medium|Medium Large|Small|Small Medium|X Large|X Small) Box/i, "Drawer Box"],
      [/Drawer X Large - File Box/i, "File Drawer"],
      [/Glass Shelf/i, "Glass Shelf"],
      [/Melamine/i, "Miscellaneous"],
      [/Slanted Shelf with Fence/i, "Slanted Shoe Shelf"],
      [/Sliding Shelf/i, "Sliding Shelf"],
      [/Tiltout Basket/i, "Tilt-out Hamper"],
      [/Elite Shoe Fence/i, "Elite Shoe Fence"],
      [/Symphony Coat Hook - (.*?)$/i, "Symphony Coat Hook"],
      [/Symphony Container Tray - (.*?)$/i, "Symphony Container Tray"],
      [/Symphony Jewelry Hook - (.*?)$/i, "Symphony Jewelry Hook"],
      [/Symphony Leather Pocket - (.*?)$/i, "Symphony Leather Pocket"],
      [/Symphony Mirror Clips - (.*?)$/i, "Symphony Mirror Clips"],
      [/Symphony Paper Tray - (.*?)$/i, "Symphony Paper Tray"],
      [/Symphony Pencil Holder - (.*?)$/i, "Symphony Pencil Holder"],
      [/Symphony Post Extensions - (.*?)$/i, "Symphony Post Extensions"],
      [/Symphony Shoe Hook - (.*?)$/i, "Symphony Shoe Hook"],
      [/Symphony Tablet Stand - (.*?)$/i, "Symphony Tablet Stand"],
      [/Symphony Triple Hook - (.*?)$/i, "Symphony Triple Hook"],
      [/Symphony Wall Organizer - Hook(.*?)$/i, "Symphony Wall Organizer - Hook"],
      [/Wire Basket(.*?)$/i, "Wire Basket"]
  ]);

  for (const [regex, newName] of nameMatchers.entries()) {
      if (regex.test(PartName)) {
          return newName;
      }
  }

  // Default to PartName if no modifications were made
  return PartName;
};


export default getExportProductName;
